import { useState, useEffect } from 'react';
import { Nav, Navbar } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import { getCSAPlusRoutes, getCSAPlusProjectDetailsRoutes } from 'sitemap-csa-plus';
import { capitalize } from 'helpers/utils';
import NavbarVerticalMenu from './NavbarVerticalMenu';
import { UilArrowFromRight, UilLeftArrowToLeft } from '@iconscout/react-unicons';
import { useAppContext } from 'providers/AppProvider';
import Button from 'components/base/Button';
import NavbarTopNav from '../navbar-horizontal/NavbarTopNav';
import { useBreakpoints } from 'providers/BreakpointsProvider';
import NavbarVerticalCollapseProvider from './NavbarVerticalCollapseProvider';

const NavbarVerticalCSA = () => {
  const {
    config: { navbarPosition, openNavbarVertical, navbarVerticalAppearance, isNavbarVerticalCollapsed },
    setConfig
  } = useAppContext();

  const { breakpoints } = useBreakpoints();

  const location = useLocation();
  const projectDetailsMatch = location.pathname.match(/^\/csa\+\/project-details\/([^/?#]+)/);
  const params = new URLSearchParams(location.search);
  const projectIdFromDetailsTabs =
    location.pathname.startsWith('/csa+/details-tabs') && params.get('projectId') ? params.get('projectId') || '' : '';
  const projectIdFromPath =
    projectDetailsMatch?.[1] || projectIdFromDetailsTabs || localStorage.getItem('projectId') || '';

  const [routes, setRoutes] = useState(
    projectIdFromPath ? getCSAPlusProjectDetailsRoutes(decodeURIComponent(projectIdFromPath)) : getCSAPlusRoutes()
  );

  useEffect(() => {
    const match = location.pathname.match(/^\/csa\+\/project-details\/([^/?#]+)/);
    const q = new URLSearchParams(location.search);
    const fromTabs =
      location.pathname.startsWith('/csa+/details-tabs') && q.get('projectId') ? q.get('projectId') || '' : '';
    const pid = match?.[1] || fromTabs || localStorage.getItem('projectId') || '';
    setRoutes(pid ? getCSAPlusProjectDetailsRoutes(decodeURIComponent(pid)) : getCSAPlusRoutes());
  }, [location.pathname, location.search]);

  return (
    <NavbarVerticalCollapseProvider>
      <Navbar
        className="navbar-vertical"
        expand="lg"
        variant=""
        data-navbar-appearance={navbarVerticalAppearance === 'darker' ? 'darker' : ''}
      >
        <Navbar.Collapse id="navbarVerticalCollapse" in={openNavbarVertical}>
          <div className="navbar-vertical-content">
            <Nav className="flex-column" as="ul" id="navbarVerticalNav">
              <Nav.Item>
                <p className="navbar-vertical-label">{capitalize('CSA+')}</p>
                <hr className="navbar-vertical-line" />
                <NavbarVerticalMenu level={1} routes={routes} />
              </Nav.Item>
            </Nav>

            {navbarPosition === 'combo' && breakpoints.down('lg') && (
              <div className="move-container">
                <div className="navbar-vertical-divider">
                  <hr className="navbar-vertical-hr" />
                </div>
                <NavbarTopNav />
              </div>
            )}
          </div>
        </Navbar.Collapse>
        <div className="navbar-vertical-footer">
          <Button
            className="navbar-vertical-toggle border-0 fw-semibold w-100 white-space-nowrap d-flex align-items-center"
            onClick={() => {
              setConfig({
                isNavbarVerticalCollapsed: !isNavbarVerticalCollapsed
              });
            }}
          >
            {isNavbarVerticalCollapsed ? (
              <UilArrowFromRight size={16} className="mb-1" />
            ) : (
              <>
                <UilLeftArrowToLeft size={16} className="mb-1" />
                <span className="ms-2">Collapsed View</span>
              </>
            )}
          </Button>
        </div>
      </Navbar>
    </NavbarVerticalCollapseProvider>
  );
};

export default NavbarVerticalCSA;
